import React from 'react';

// Minimal, geometrically accurate SVG flags (not emoji).
// Each flag is a 24x16 viewBox and rendered at the requested size.

export const FlagAU = ({ size = 20, className = '' }) => (
  <svg viewBox="0 0 24 16" width={size} height={(size * 16) / 24} className={className} aria-hidden="true">
    <rect width="24" height="16" fill="#00247D" />
    {/* Union Jack canton */}
    <g clipPath="url(#au-canton)">
      <rect width="12" height="8" fill="#00247D" />
      <path d="M0 0L12 8M12 0L0 8" stroke="#FFF" strokeWidth="1.6" />
      <path d="M0 0L12 8M12 0L0 8" stroke="#CF142B" strokeWidth="0.8" />
      <path d="M6 0V8M0 4H12" stroke="#FFF" strokeWidth="2.4" />
      <path d="M6 0V8M0 4H12" stroke="#CF142B" strokeWidth="1.2" />
    </g>
    <clipPath id="au-canton"><rect width="12" height="8" /></clipPath>
    {/* Commonwealth Star (simplified) */}
    <polygon points="6,10.4 6.55,11.7 7.95,11.7 6.8,12.5 7.25,13.9 6,13.1 4.75,13.9 5.2,12.5 4.05,11.7 5.45,11.7" fill="#FFF" />
    {/* Southern Cross — small circles stand in for stars */}
    <circle cx="17.5" cy="4.5" r="0.6" fill="#FFF" />
    <circle cx="20" cy="7" r="0.65" fill="#FFF" />
    <circle cx="18.5" cy="10" r="0.65" fill="#FFF" />
    <circle cx="21" cy="11.5" r="0.55" fill="#FFF" />
    <circle cx="19.5" cy="13" r="0.5" fill="#FFF" />
  </svg>
);

export const FlagCN = ({ size = 20, className = '' }) => (
  <svg viewBox="0 0 24 16" width={size} height={(size * 16) / 24} className={className} aria-hidden="true">
    <rect width="24" height="16" fill="#EE1C25" />
    {/* Large star */}
    <polygon
      points="4.6,2.4 5.26,4.4 7.35,4.4 5.66,5.65 6.3,7.65 4.6,6.4 2.9,7.65 3.54,5.65 1.85,4.4 3.94,4.4"
      fill="#FFDE00"
    />
    {/* Four small stars */}
    <polygon points="8.5,1.6 8.78,2.4 9.63,2.4 8.95,2.92 9.2,3.75 8.5,3.26 7.8,3.75 8.05,2.92 7.37,2.4 8.22,2.4" fill="#FFDE00" />
    <polygon points="10,3.6 10.28,4.4 11.13,4.4 10.45,4.92 10.7,5.75 10,5.26 9.3,5.75 9.55,4.92 8.87,4.4 9.72,4.4" fill="#FFDE00" />
    <polygon points="10,6 10.28,6.8 11.13,6.8 10.45,7.32 10.7,8.15 10,7.66 9.3,8.15 9.55,7.32 8.87,6.8 9.72,6.8" fill="#FFDE00" />
    <polygon points="8.5,7.6 8.78,8.4 9.63,8.4 8.95,8.92 9.2,9.75 8.5,9.26 7.8,9.75 8.05,8.92 7.37,8.4 8.22,8.4" fill="#FFDE00" />
  </svg>
);

export const FlagIN = ({ size = 20, className = '' }) => (
  <svg viewBox="0 0 24 16" width={size} height={(size * 16) / 24} className={className} aria-hidden="true">
    <rect width="24" height="5.333" y="0" fill="#FF9933" />
    <rect width="24" height="5.333" y="5.333" fill="#FFFFFF" />
    <rect width="24" height="5.333" y="10.667" fill="#138808" />
    {/* Ashoka Chakra */}
    <g transform="translate(12 8)">
      <circle r="1.9" fill="none" stroke="#000080" strokeWidth="0.25" />
      <circle r="0.35" fill="#000080" />
      {Array.from({ length: 24 }).map((_, i) => (
        <line
          key={i}
          x1="0"
          y1="0"
          x2="0"
          y2="-1.85"
          stroke="#000080"
          strokeWidth="0.12"
          transform={`rotate(${(360 / 24) * i})`}
        />
      ))}
    </g>
  </svg>
);

export const FLAG_FOR = {
  en: FlagAU,
  zh: FlagCN,
  hi: FlagIN,
};
